import { useEffect, useState } from "react"
import "./SearchHints.css";
import { useNavigate, createSearchParams } from "react-router-dom";

function SearchHint(props) {
    const navigate = useNavigate()
    const search = (testo) => navigate({pathname:'/search', search: `?${createSearchParams({q: testo})}`})
    return <button onClick={(e) => {e.preventDefault(); search(props.testo)}}>{props.testo}</button>
}

function SearchHints() {

    return (
        <div>
            <h2 className="search-hints-title">
                Esempi di ricerca
            </h2>
            <div className="search-hints"> 
                <SearchHint testo="notebook asus amd"/>
                <SearchHint testo="tastiera logitech"/>
                <SearchHint testo="stampante HP"/>
                <SearchHint testo="iphone 14"/>
                <SearchHint testo="ssd 250 gb"/>
                <SearchHint testo="switch non gestito"/>
                <SearchHint testo="VLX0B17715"/>
            </div>
      </div>
    )
}

export default SearchHints